import api from './api'

const base = (deviceId) => `/managed-devices/${deviceId}/firewall`

export const managedDeviceFirewallApi = {
  listRules: async (deviceId, direction) => {
    const params = direction ? { direction } : {}
    const { data } = await api.get(`${base(deviceId)}/rules`, { params })
    return data
  },

  createRule: async (deviceId, body) => {
    const { data } = await api.post(`${base(deviceId)}/rules`, body)
    return data
  },

  updateRule: async (deviceId, ruleId, body) => {
    const { data } = await api.put(`${base(deviceId)}/rules/${ruleId}`, body)
    return data
  },

  deleteRule: async (deviceId, ruleId) => {
    await api.delete(`${base(deviceId)}/rules/${ruleId}`)
  },

  reorder: async (deviceId, entries) => {
    const { data } = await api.put(`${base(deviceId)}/rules/reorder`, { entries })
    return data
  },

  setOutputDefault: async (deviceId, action) => {
    const { data } = await api.put(`${base(deviceId)}/output-default`, { action })
    return data
  },

  getAvailableSources: async (deviceId) => {
    const { data } = await api.get(`${base(deviceId)}/available-sources`)
    return data
  },
}
